export const REDIRECT_URL_QUERY_PARAM = 'redirectUrlPreview';
